var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextEpisode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NextEpisode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "NextEpisode_path",
    fill: "#aaaaaa",
    d: "M78.098,68.077H41.235c-4.837,0-6.569,1.583-6.569,6.009V99.12 c0,4.425,1.732,6.009,6.569,6.009h36.862c4.837,0,6.569-1.584,6.569-6.009V74.086C84.667,69.661,82.935,68.077,78.098,68.077z  M74.24,88.651C72.965,89.404,52.11,101.463,50.6,102.3c-1.106,0.614-2.557-0.063-2.557-1.462V73.549 c0-1.269,1.313-2.213,2.61-1.471c1.04,0.595,21.814,12.592,23.587,13.618C75.404,86.37,75.385,87.978,74.24,88.651z M70.866,2.268 C31.728,2.268,0,33.996,0,73.134C0,112.272,31.728,144,70.866,144c39.139,0,70.866-31.728,70.866-70.866 C141.732,33.996,110.005,2.268,70.866,2.268z M93.667,106.085c0,6.687-2.355,9.081-8.934,9.081H34.601 c-6.579,0-8.935-2.395-8.935-9.081V68.248c0-6.688,2.355-9.081,8.935-9.081h50.132c6.578,0,8.934,2.394,8.934,9.081V106.085z  M106.417,93.335c0,6.687-2.355,9.081-8.934,9.081h-0.067l0.001-41.08c0-4.425-1.732-6.009-6.569-6.009h-52.43 c0.02-6.624,2.381-8.911,8.934-8.911h50.132c6.578,0,8.934,2.394,8.934,9.081V93.335z M119.459,80.375 c0,6.688-2.355,9.082-8.934,9.082h-0.067l0.001-41.08c0-4.425-1.732-6.009-6.569-6.009H51.46c0.02-6.624,2.381-8.911,8.934-8.911 h50.132c6.578,0,8.934,2.394,8.934,9.081V80.375z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextEpisode);
export default __webpack_public_path__ + "static/media/next_episode.f23de868.svg";
export { ForwardRef as ReactComponent };